import type { BrandPreviewId } from '@/lib/brand-preview/shared';
import { hyroxHubFvdCss } from '@/lib/brand-preview/hyrox-theme';

/**
 * The Hyrox demo skin (signed preview cookie) on the athlete hub.
 * BrandPreviewSkin repaints the OLD token set (--fv-*) on <html>. The
 * reskinned hub reads the v8 tokens (--fvd-*), so without this the hub would
 * come out Fitvent teal inside a Hyrox demo. BrandPreviewSkin now emits the v8
 * tokens too; HubShell repeats them so the shell is right even where it renders
 * without the layout's skin. The hub is dark-only under that skin, so there is
 * no light half.
 *
 * (The emailed ticket page's organiser accent lives in
 * components/hub/ticket/organiser-skin.ts.)
 */

/** CSS for the hub under a brand preview, or '' when there is none. The
 *  values live with the rest of the skin in lib/brand-preview/hyrox-theme.ts,
 *  so the dashboard and the hub cannot drift apart. */
export function hubBrandSkinCss(brand: BrandPreviewId | null | undefined): string {
  if (brand !== 'hyrox') return '';
  return hyroxHubFvdCss();
}

